import React, { useEffect, useState } from "react";
import Cursor from "./components/Cursor";
import Nav from "./components/Nav";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import About from "./components/About";
import Services from "./components/Services";
import Results from "./components/Results";
import Testimonials from "./components/Testimonials";
import Footer from "./components/Footer";
import BookingModal from "./components/BookingModal";
import ServiceDetailModal from "./components/ServiceDetailModal";
import StickyBook from "./components/StickyBook";

export default function App() {
  const [bookOpen, setBookOpen] = useState(false);
  const [bookService, setBookService] = useState(null);
  const [detail, setDetail] = useState(null);

  useEffect(() => {
    const obs = new IntersectionObserver(
      (entries) => entries.forEach((e) => { if (e.isIntersecting) e.target.classList.add("in"); }),
      { threshold: 0.15 }
    );
    document.querySelectorAll(".reveal").forEach((el) => obs.observe(el));
    return () => obs.disconnect();
  }, []);

  const onBook = (svc) => {
    setBookService(typeof svc === "string" ? svc : null);
    setBookOpen(true);
  };

  return (
    <div className="min-h-screen relative overflow-x-clip" data-testid="app-root">
      <Cursor />
      <Nav onBook={onBook} />
      <main id="main-content">
        <Hero onBook={onBook} />
        <Marquee />
        <About />
        <Services onBook={onBook} onLearn={setDetail} />
        <Results />
        <Testimonials />
        <Footer onBook={onBook} />
      </main>
      <StickyBook onBook={onBook} />
      <BookingModal open={bookOpen} initialService={bookService} onClose={() => setBookOpen(false)} />
      <ServiceDetailModal service={detail} onClose={() => setDetail(null)} onBook={onBook} />
    </div>
  );
}
